import { getToken } from '@efsa/dlw-authenticator';

export default async function (headers: any) {
  // If no token is present, force login
  const token = await getToken();
  if (token.length) {
    headers.set('Authorization', `Bearer ${token}`);
  }
  return headers;
}
